// extracted by mini-css-extract-plugin
export var slideBox = "slide-box_pjHbCjHGEZjsghq1SZ6s";
export var slideBoxButton = "slide-box__button_g0nmPuBh0TFQRRAaPsp8";
export var slideBoxCaption = "slide-box__caption_huNw1RrmSMzkNmM7ePDU";
export var slideBoxIcon = "slide-box__icon_PZAXfBIwLt8W4sDOdETZ";